<template>
	<div class="error-view">
		<img
			class="error-view__image"
			src="../../assets/glitch.webp"
			:alt="t('error.title')"
		/>

		<div class="error-view__content">
			<h2 class="body-md body--highlighted">
				{{ t('error.title') }}
			</h2>
			<h3
				v-if="error?.translationKey"
				class="body-sm"
			>
				{{ t(error?.translationKey ?? 'error.message.generic') }}
			</h3>
			<span class="body-xs">
				{{ t('error.description') }}
			</span>
		</div>

		<HYButton
			class="error-view__button"
			variant="outlined"
			size="sm"
			fitContent
			icon="AngleLeft"
			@click="handleClickRetry"
		>
			{{ t('error.goBack') }}
		</HYButton>
	</div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { HYButton } from '@voicemod1/harmony-ui';

import { useStore } from '../../store';

const { t } = useI18n();

const { error } = storeToRefs(useStore());

const handleClickRetry = () => {
	const store = useStore();
	store.clearError();
};
</script>

<style scoped lang="scss">
.error-view {
	position: relative;

	display: flex;
	flex-direction: column;
	gap: var(--hy-space-lg);
	align-items: center;
	justify-content: center;

	min-width: 294px;
	padding: var(--hy-space-md) 0;

	&__image {
		object-fit: contain;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: var(--hy-space-sm);
		align-items: center;
		justify-content: center;

		h2,
		h3 {
			margin: 0;
		}
	}
}
</style>
